export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"We make it easy for you to hire, onboard, and pay your global team in fiat or crypto, while ensuring full tax compliance."},{"property":"og:url","content":"https://pay.riseworks.io"},{"property":"og:type","content":"website"},{"property":"og:title","content":"Rise Pay"},{"property":"og:description","content":"We make it easy for you to hire, onboard, and pay your global team in fiat or crypto, while ensuring full tax compliance."},{"property":"og:image","content":"https://uploads-ssl.webflow.com/624f0c4263953ffe82f4e446/63b3509f28b47fe5ff366646_homepage.png"},{"name":"twitter:card","content":"summary_large_image"},{"property":"twitter:domain","content":"riseworks.io"},{"property":"twitter:url","content":"https://www.riseworks.io/"},{"name":"twitter:title","content":"Rise | Crypto Payroll & Web3 Workforce Solutions"},{"name":"twitter:description","content":"We make it easy for you to hire, onboard, and pay your global team in fiat or crypto, while ensuring full tax compliance."},{"name":"twitter:image","content":"https://assets-global.website-files.com/624f0c4263953ffe82f4e446/63b3509f28b47fe5ff366646_homepage.png"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon/favicon.ico"},{"rel":"shortcut icon","type":"image/x-icon","href":"/favicon/favicon.ico"},{"rel":"apple-touch-icon","type":"image/x-icon","href":"/favicon/apple-icon-57x57.png","sizes":"57x57"},{"rel":"apple-touch-icon","type":"image/x-icon","href":"/favicon/apple-icon-60x60.png","sizes":"60x60"},{"rel":"apple-touch-icon","type":"image/x-icon","href":"/favicon/apple-icon-72x72.png","sizes":"72x72"},{"rel":"apple-touch-icon","type":"image/x-icon","href":"/favicon/apple-icon-76x76.png","sizes":"76x76"},{"rel":"apple-touch-icon","type":"image/x-icon","href":"/favicon/apple-icon-114x114.png","sizes":"114x114"},{"rel":"apple-touch-icon","type":"image/x-icon","href":"/favicon/apple-icon-120x120.png","sizes":"120x120"},{"rel":"apple-touch-icon","type":"image/x-icon","href":"/favicon/apple-icon-144x144.png","sizes":"144x144"},{"rel":"apple-touch-icon","type":"image/x-icon","href":"/favicon/apple-icon-152x152.png","sizes":"152x152"},{"rel":"apple-touch-icon","type":"image/x-icon","href":"/favicon/apple-icon-180x180.png","sizes":"180x180"},{"rel":"icon","type":"image/png","href":"/favicon/android-icon-192x192.png","sizes":"192x192"},{"rel":"icon","type":"image/png","href":"/favicon/android-icon-144x144.png","sizes":"144x144"},{"rel":"icon","type":"image/png","href":"/favicon/android-icon-96x96.png","sizes":"96x96"},{"rel":"icon","type":"image/png","href":"/favicon/android-icon-72x72.png","sizes":"72x72"},{"rel":"icon","type":"image/png","href":"/favicon/android-icon-36x36.png","sizes":"36x36"},{"rel":"icon","type":"image/png","href":"/favicon/android-icon-16x16.png","sizes":"16x16"}],"style":[],"script":[],"noscript":[],"title":"Rise Pay","htmlAttrs":{"lang":"en"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const runtimeCompiler = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true